import { uuid } from '@/src/shared/lib/uuid'

const WINDOW_ID = uuid()

export function windowIdGet(): string {
  return WINDOW_ID
}
